// Qaysi 614 ekrandan qaysilari JONLI (implement qilingan). Qolgani — REJALASHTIRILGAN
// (ko'pi server-endpoint yoki infra kutadi). Modul-index va overview shu manbadan
// «bajarildi %» ni hisoblaydi. Ekran jonli bo'lgach shu yerga qo'shiladi.
//
// `route` bo'lsa — modul-index'da bosiladigan havola. Bo'lmasa (masalan login/
// sessiya-tugadi — oqim ichida) — «JONLI» belgisi, havolasiz.

export interface ScreenStatus {
  /** Jonli ekranga yo'l. Yo'q bo'lsa — implement qilingan lekin to'g'ridan navigatsiyasiz. */
  route?: string
  /** Skelet (s12c): UI mo'ljal-layout + typed adapter TAYYOR, lekin HAQIQIY ma'lumot infra
   *  kutadi (ClickHouse/event-ETL/to'lov). Navigatsiya bor (route), LEKIN "jonli" hisobiga
   *  KIRMAYDI — halol %. Data pipeline kelganda adapter ulanadi → jonli bo'ladi. */
  skeleton?: boolean
}

export const SCREEN_STATUS: Record<string, ScreenStatus> = {
  // A1 — auth
  'A1.01': {}, // Kirish (oqim ichida)
  'A1.03': { route: '/dev/auth' },
  'A1.04': { route: '/dev/auth' },
  'A1.05': {}, // Sessiya tugadi (oqim ichida)
  'A1.06': { route: '/dev/auth' },
  'A1.07': { route: '/dev/auth' },
  // A2 — dashboard
  'A2.01': { route: '/' },
  'A2.02': { route: '/realtime' }, // real-time monitor (rolling hisoblagich, GET /admin/realtime 5s-poll)
  'A2.03': { route: '/moderation/dashboard' }, // moderatsiya dashboard'i (trust&safety navbat-yig'indisi)
  'A2.07': { route: '/support/dashboard' }, // support dashboard'i (tiket holat/prioritet taqsimoti)
  'A2.08': { route: '/security/dashboard' }, // xavfsizlik dashboard'i (audit+four-eyes+xodim)
  'A2.09': { route: '/my-tasks' }, // mening vazifalarim (shaxsiy navbat: tayinlangan tiket + four-eyes tasdiq)
  'A2.04': { route: '/finance/dashboard' }, // moliya dashboard'i (hamyon+tranzaksiya)
  'A2.05': { route: '/infra' }, // infra dashboard'i (runtime+DB sog'ligi, GET /admin/infra read-only)
  'A2.06': { route: '/growth' }, // o'sish dashboard'i (analitika + davlat-reyting)
  'A2.12': { route: '/tv' },
  'A2.10': { route: '/alerts-center' }, // ogohlantirishlar markazi — JONLI: admin_alert_rules CRUD (000250)
  'A2.11': { route: '/dashboard-builder' }, // dashboard konstruktori — JONLI: admin_dashboards layout CRUD (000250)
  // A3 — users
  'A3.01': { route: '/users' },
  'A3.07': {}, // umumiy ma'lumot / karta (/users/:id — «Karta» bilan)
  'A3.09': {}, // aloqa ma'lumotlari L2/L3 (/users/:id/contact — kartadan)
  'A3.10': {}, // sessiyalar/qurilmalar (/users/:id/sessions — kartadan)
  'A3.11': {}, // kirish tarixi — to'liq qurilma/login izi, bekor qilinganlar ham (/users/:id/login-history — kartadan; A3.10 aktivlardan farqli)
  'A3.12': {}, // chatlar ro'yxati / a'zo guruh-kanallar (/users/:id/groups — kartadan)
  'A3.13': {}, // egalik qilgan guruh/kanallar (/users/:id/owned-groups — kartadan)
  'A3.15': {}, // to'lovlar tarixi / hamyon (/users/:id/wallet — kartadan)
  'A3.16': {}, // stars/sovg'a tranzaksiyalari (/users/:id/gifts — kartadan, live_gift filtri)
  'A3.21': {}, // bog'liq akkauntlar (/users/:id/related — device_uid baham ko'rish, anti-fraud)
  'A3.22': {}, // risk skori va signal'lar (/users/:id/risk — kartadan; strike/report/related/ban agregati, GET /admin/users/:id/risk)
  'A3.26': {}, // ogohlantirish yuborish (/users/:id/warnings — kartadan; durable user_warnings + push SendToUser, POST /admin/users/:id/warn)
  'A3.18': {}, // strike va cheklovlar tarixi (/users/:id/strikes — kartadan)
  'A3.19': {}, // moderatsiya izohlari — ichki xodim izohlari, append-only (/users/:id/notes — kartadan; GET /admin/users/:id/notes)
  'A3.38': {}, // xodim izohini qo'shish (/users/:id/notes — bir ekranда ko'rish+qo'shish; POST /admin/users/:id/notes)
  'A3.17': {}, // shikoyatlar undan/unga (/users/:id/reports — kartadan)
  'A3.20': {}, // support tiketlari (/users/:id/tickets — kartadan)
  'A3.14': {}, // egalik qilgan botlar (/users/:id/bots — kartadan)
  'A3.28': { route: '/users' }, // bloklash (Users ekrani ichida)
  'A3.31': { route: '/users' }, // majburiy chiqarish / barcha sessiyalar (Users row-action, DangerDialog L2)
  'A3.29': { route: '/users' }, // blokdan chiqarish
  // A4 — guruh/kanal
  'A4.01': { route: '/groups' }, // guruh/kanal ro'yxati
  // A5 — botlar
  'A5.01': { route: '/bots' }, // botlar ro'yxati (users.is_bot)
  'A5.02': {}, // bot kartasi (/bots/:id — GET /admin/bots/:id to'liq config)
  'A5.09': {}, // bot yoq/o'chir (revoked) — bot-kartadan DangerDialog L2, POST /admin/bots/:id
  'A5.14': {}, // rasmiy-belgi (is_official) — bot-kartadan DangerDialog L2, POST /admin/bots/:id
  'A5.10': {}, // buyruq/tavsif tahrir-forma — bot-kartadan (inline edit), POST /admin/bots/:id
  'A5.03': {}, // bot egasi — bot-kartada seksiya, GET /admin/bots/:id/owner (bot_platform.bots.owner_id)
  'A5.06': {}, // webhook holati — bot-kartada seksiya, GET /admin/bots/:id/webhook (bot_webhooks)
  'A5.16': {}, // mini-app'lar — bot-kartada seksiya, GET /admin/bots/:id/apps (bot_apps)
  'A5.17': {}, // mini-app temasi — bot-kartada seksiya, GET /admin/bots/:id/app-settings (bot_app_settings)
  'A5.20': {}, // skrinshot/preview media — bot-kartada seksiya, GET /admin/bots/:id/preview-media (bot_preview_media)
  'A5.30': {}, // bot API kaliti monitoringi — bot-kartada seksiya, GET /admin/bots/:id/token (bots.token_prefix, sekret emas)
  'A5.28': {}, // business ulanishlar — bot-kartada seksiya, GET /admin/bots/:id/business (business_connections)
  'A5.29': {}, // affiliate dastur — bot-kartada seksiya, GET /admin/bots/:id/affiliate (bot_affiliate_programs)
  'A5.26': {}, // o'yinlar ro'yxati — bot-kartada seksiya, GET /admin/bots/:id/games (bot_games)
  'A5.27': {}, // o'yin + leaderboard (o'yinchi soni) — bot-kartada seksiya, GET /admin/bots/:id/games (game_scores)
  'A5.08': {}, // botga qarshi shikoyatlar — bot-kartada seksiya, GET /admin/users/:id/reports (reuse)
  'A5.12': {}, // botni bloklash — bot-kartadan DangerDialog L3, POST /admin/users/:id/ban (reuse)
  'A5.04': {}, // statistika (xabar-faollik) — bot-kartada seksiya, GET /admin/bots/:id/stats (messages)
  'A5.05': {}, // API foydalanish (update-usage) — bot-kartada seksiya, GET /admin/bots/:id/stats (bot_updates)
  'A4.04': {}, // chat kartasi (/groups/:id — ro'yxatdan «Karta» bilan)
  'A4.29': {}, // verifikatsiya berish/olib tashlash (/groups/:id kartasidagi tugma; POST /admin/groups/:id/verify → dialogs.verified, user Info'да ham)
  'A4.28': {}, // egalikni ma'muriy o'tkazish (/groups/:id kartasidagi tugma; POST /admin/groups/:id/transfer-owner — atomik, yangi ega faol a'zo bo'lishi shart)
  'A4.30': {}, // username majburan bo'shatish (/groups/:id kartasidagi tugma, username bor bo'lsa; POST /admin/groups/:id/release-username — partial-unique index → qaytadan olinadi)
  'A4.27': {}, // kanalni bloklash/ochish (/groups/:id kartasidagi tugma; POST /admin/groups/:id/block → dialogs.admin_blocked; ENFORCED send yo'lida ErrGroupBlocked, integration-test bilan)
  'A4.05': {}, // a'zolar ro'yxati (/groups/:id/members — kartadan)
  'A4.06': {}, // adminlar (/groups/:id/admins — members filtered, backend'siz)
  'A4.07': {}, // sozlamalar snapshot'i (/groups/:id/settings — GetGroup settings ustunlari)
  'A4.12': {}, // ulangan botlar (/groups/:id/bots — members is_bot filtri)
  'A4.21': {}, // guruh/kanalga qarshi shikoyatlar (/groups/:id/reports)
  'A4.08': {}, // taklif havolalari (/groups/:id/invites — kartadan)
  'A4.09': {}, // qo'shilish so'rovlari (/groups/:id/join-requests — kartadan)
  'A4.10': {}, // forum topiclari (/groups/:id/topics — is_forum bo'lsa)
  'A4.13': {}, // kontent/xabar tarixi (/groups/:id/messages — kartadan)
  'A4.14': {}, // media galereya (/groups/:id/media — kartadan)
  'A4.16': {}, // o'sish grafigi (/groups/:id/growth — kartadan)
  'A4.17': {}, // statistika (/groups/:id/stats — kartadan)
  'A4.19': {}, // boost holati (/groups/:id/boosts — kartadan)
  'A4.22': {}, // moderatsiya tarixi / admin jurnali (/groups/:id/admin-log — kartadan)
  // A6 — kontent moderatsiyasi (P2 reports tizimi)
  'A6.01': { route: '/moderation' }, // umumiy moderatsiya navbati
  'A6.03': { route: '/moderation/cat/csam' }, // CSAM navbati (izolyatsiya)
  'A6.04': { route: '/moderation/cat/violence' }, // zo'ravonlik/terrorizm
  'A6.05': { route: '/moderation/cat/spam' }, // spam
  'A6.06': { route: '/moderation/cat/fraud' }, // firibgarlik
  'A6.07': { route: '/moderation/cat/copyright' }, // mualliflik huquqi (DMCA)
  'A6.08': { route: '/moderation/cat/doxxing' }, // doxxing
  'A6.15': {}, // shikoyat kartasi + qaror (/moderation/:id — navbatdan)
  'A6.02': { route: '/moderation/priority' }, // Prioritetli navbat — yuqori-xavf reports risk-ranked (GET /admin/moderation/priority: kategoriya-og'irlik + flood-hajm + yosh)
  'A6.13': { route: '/moderation/mine' }, // Mening navbatim — pull-based claim (POST /admin/moderation/claim-next SKIP LOCKED, GET /mine, POST /reports/:id/release)
  'A6.21': { route: '/moderation/escalated' }, // Eskalatsiya — yuqori tierга ko'tarish (POST /reports/:id/escalate senior|specialist|lead, GET /moderation/escalated, POST /de-escalate)
  'A6.20': { route: '/moderation/bulk' }, // Ommaviy qaror — bir xil kontent guruhini bir marta hal qilish (POST /admin/moderation/bulk-resolve, status-guarded atomik)
  'A6.29': { route: '/automod/rules' }, // Kalit so'z ro'yxatlari — auto-moderatsiya qoidalari (GET/POST /admin/moderation/rules)
  'A6.30': { route: '/automod/rules' }, // Regex qoidalari (is_regex bilan bir ekranda)
  'A6.35': { route: '/automod/rules' }, // Qoida testi (ekranда inline namuna-sinov, POST /admin/moderation/test)
  'A6.36': { route: '/automod/flags' }, // Avtomatik qarorlar / kontent-flag review (GET /admin/moderation/flags)
  'A7.03': { route: '/moderation/groups' }, // guruhlash (obyekt bo'yicha, reports agregat)
  'A7.04': { route: '/moderation/reporters' }, // shikoyatchi ishonchliligi (reports agregat)
  // A7 — support tiketlar (P/A7 tickets tizimi)
  'A7.06': { route: '/support' }, // support tiketlar navbati
  'A7.13': { route: '/support/sla' }, // SLA monitoringi (ochiq tiket yosh-guruhlari)
  'A7.14': { route: '/support/overdue' }, // kechikkan tiketlar (yosh > SLA)
  'A7.15': { route: '/canned-responses' }, // Javob shablonlari — GET/POST /admin/canned-responses (kategoriya+usage)
  'A7.17': { route: '/escalation-rules' }, // Eskalatsiya qoidalari — rules CRUD + jonli buzilishlar (GET /admin/escalation-rules + /escalation-breaches)
  'A7.07': {}, // tiket kartasi + yozishma + holat (/support/:id — navbatdan)
  // A9 — verifikatsiya (verification_requests tizimi)
  'A9.01': { route: '/verification' }, // arizalar navbati
  'A9.02': {}, // ariza kartasi + qaror (/verification/:id — navbatdan)
  'A9.12': { route: '/verification/registry' }, // tasdiqlanganlar reyestri
  'A9.13': { route: '/verification/rejected' }, // rad etilgan/soxta arizalar
  'A9.14': { route: '/verification/stats' }, // verifikatsiya statistikasi (status+kind)
  // A8 — strike/ban
  'A8.01': { route: '/users/banned' }, // aktiv cheklovlar (bloklangan userlar)
  'A8.03': { route: '/strikes' }, // so'nggi strayklar (progressiv-jazo)
  'A8.19': { route: '/strikes/stats' }, // cheklov statistikasi (daraja + amaldagi/tugagan)
  'A8.10': { route: '/appeals' }, // apellyatsiyalar navbati
  'A8.11': {}, // apellyatsiya kartasi + qaror (/appeals/:id — navbatdan)
  'A8.02': { route: '/users/ban-log' }, // ban/unban tarixi (audit filtered)
  // A10 — moliya
  'A10.01': { route: '/finance' }, // barcha tranzaksiyalar
  'A10.02': {}, // tranzaksiya kartasi (/finance/:id — ro'yxatdan)
  'A10.09': { route: '/finance/wallets' }, // stars/hamyon balanslar taqsimoti
  // A10.03–36 JONLI — MyGram ichki iqtisodi (Take/Ball/Stars/tokenlar) ustidan real
  // funksional ekranlar: hisobotlar wallet_txns/points_ledger/bot_star_charges/
  // market_trades'dan hisoblanadi; config-CRUD + workflow finance_* jadvallarida
  // (migratsiya 000241). FinanceReal `:id` → real ekran. Fiat-provayder KERAK EMAS.
  'A10.03': { route: '/finance/planned/A10.03' },
  'A10.04': { route: '/finance/planned/A10.04' },
  'A10.05': { route: '/finance/planned/A10.05' },
  'A10.06': { route: '/finance/planned/A10.06' },
  'A10.07': { route: '/finance/planned/A10.07' },
  'A10.08': { route: '/finance/planned/A10.08' },
  'A10.10': { route: '/finance/planned/A10.10' },
  'A10.11': { route: '/finance/planned/A10.11' },
  'A10.12': { route: '/finance/planned/A10.12' },
  'A10.13': { route: '/finance/planned/A10.13' },
  'A10.14': { route: '/finance/planned/A10.14' },
  'A10.15': { route: '/finance/planned/A10.15' },
  'A10.16': { route: '/finance/planned/A10.16' },
  'A10.17': { route: '/finance/planned/A10.17' },
  'A10.18': { route: '/finance/planned/A10.18' },
  'A10.19': { route: '/finance/planned/A10.19' },
  'A10.20': { route: '/finance/planned/A10.20' },
  'A10.21': { route: '/finance/planned/A10.21' },
  'A10.22': { route: '/finance/planned/A10.22' },
  'A10.23': { route: '/finance/planned/A10.23' },
  'A10.24': { route: '/finance/planned/A10.24' },
  'A10.25': { route: '/finance/planned/A10.25' },
  'A10.26': { route: '/finance/planned/A10.26' },
  'A10.27': { route: '/finance/planned/A10.27' },
  'A10.28': { route: '/finance/planned/A10.28' },
  'A10.29': { route: '/finance/planned/A10.29' },
  'A10.30': { route: '/finance/planned/A10.30' },
  'A10.31': { route: '/finance/planned/A10.31' },
  'A10.32': { route: '/finance/planned/A10.32' },
  'A10.33': { route: '/finance/planned/A10.33' },
  'A10.34': { route: '/finance/planned/A10.34' },
  'A10.35': { route: '/finance/planned/A10.35' },
  'A10.36': { route: '/finance/planned/A10.36' },
  // A23 — staff
  'A23.01': { route: '/staff' }, // xodimlar ro'yxati (GET /admin/staff, jonli)
  'A23.02': {}, // xodim kartasi (/staff/member/:id — ro'yxatdan)
  'A23.03': { route: '/staff/roles' }, // rollar boshqaruvi (server /admin/roles)
  // A11 — geo
  'A11.02': { route: '/geo' },
  'A11.03': {}, // davlat kartasi (/geo/:code — ro'yxatdan)
  'A11.11': { route: '/geo/prefixes' }, // raqam prefikslari (dial-kod agregat)
  'A11.20': { route: '/geo/growth' }, // davlat bo'yicha o'sish (reyting-bar)
  'A11.04': { route: '/geo' }, // davlat blok (four-eyes producer)
  'A11.22': { route: '/geo/changelog' }, // o'zgarishlar jurnali (audit filtered)
  'A11.18': { route: '/geo/sanctions' }, // sanksiya-tekshiruv (OFAC/EU × reyestr, read-only)
  // A18 — security
  // A28 — mening hisobim (klient identity + interfeys)
  'A28.01': { route: '/account' }, // mening profilim
  'A28.04': { route: '/account/interface' }, // til + mavzu
  'A28.05': { route: '/account/help' }, // yordam va qo'llanma
  'A28.06': { route: '/account/shortcuts' }, // klaviatura yorliqlari
  'A28.02': { route: '/account/security' }, // xavfsizlik+RBAC-ruxsatlar (2FA/qurilma=backend-pending)
  'A28.03': { route: '/account/notifications' }, // bildirishnoma-prefs (client localStorage)
  // NB: Bozor/Ball (s10 iqtisod) — bu TZ-614 modul EMAS (yangi feature). Modul-
  // indeksga qo'shilmaydi (boshqa domen). Ular chap menyudagi «Bozor»/«Ball»
  // orqali JONLI reachable: /market/sellers, /market/categories,
  // /points/earn-rules, /points/catalog, /points/suspicions.
  // A21 — Stiker/emoji katalog (10 §A21): foydalanuvchi to'plamlari + moderatsiya.
  'A21.01': { route: '/stickers/moderation' }, // stiker to'plamlari moderatsiyasi (tasdiq/rad)
  // A22 — lokalizatsiya (klient i18n kataloglari)
  'A22.01': { route: '/localization' }, // tillar ro'yxati + qamrov
  'A22.03': { route: '/localization/keys' }, // kalitlar ro'yxati (catalog, client-side)
  'A22.05': { route: '/localization/missing' }, // yetishmayotgan tarjimalar (en-tenglik evristikasi)
  'A22.14': { route: '/localization/stats' }, // tarjima statistikasi (til + namespace)
  'A22.02': { route: '/localization/packs' }, // til paketlari (kalit-soni/qamrov/JSON-eksport)
  'A22.06': { route: '/localization/plurals' }, // pluralizatsiya qoidalari (CLDR ref)
  'A22.10': { route: '/localization/qc' }, // sifat nazorati (bo'sh/placeholder/tarjimasiz)
  'A22.11': { route: '/localization/export' }, // import/eksport (JSON/CSV/PO)
  'A22.04': { route: '/localization/editor' }, // tarjima muharriri (offline: tahrir→patch-yuklash)
  'A22.13': { route: '/localization/glossary' }, // glossariy (curated domen-atamalar)
  // A14 — feature-flag (app_settings feature_*)
  'A14.01': { route: '/flags' }, // flag ro'yxati
  'A14.02': {}, // flag kartasi (/flags/:key — ro'yxatdan)
  'A14.03': { route: '/flags/toggle' }, // flag yoqish/o'chirish (jonli POST /admin/settings/flags)
  'A14.04': { route: '/flags/rollout' }, // bosqichma-bosqich yoyish % (value:"N%", server per-user bucket)
  'A14.05': { route: '/flags/segments' }, // auditoriya-segment (davlat/platforma → /settings/features gate)
  'A14.06': { route: '/flags/kill' }, // kill-switch (L3 DangerDialog → enabled:false)
  'A14.07': { route: '/flags/deps' }, // flag bog'liqliklari (dependency → /settings/features fixpoint-gate)
  'A14.14': { route: '/flags/schema' }, // flag qiymat-sxemasi (SetFlag write-time validatsiya)
  'A14.09': { route: '/flags/experiments' }, // A/B tajribalar (variant+og'irlik, per-user assign)
  'A14.10': { route: '/flags/experiments' }, // A/B variant taqsimot preview (haqiqiy assign-funksiya)
  'A14.13': { route: '/flags/history' }, // flag o'zgarish tarixi (audit-asosli, per-flag timeline)
  'A14.16': { route: '/flags/history' }, // qiymat rollback (tarixdan «Qaytarish» → SetFlag)
  'A14.08': { route: '/flags/changelog' }, // o'zgarishlar jurnali (audit-filtr, read-only)
  'A14.12': { route: '/flags/config' }, // remote config qiymatlari (read-only, tur-aniqlash)
  // A15 — bildirishnoma/broadcast (GET/POST /admin/broadcasts + /push/health)
  'A15.01': { route: '/broadcasts' }, // broadcast compose (draft)
  'A15.02': { route: '/broadcasts' }, // broadcast tarixi
  'A15.06': { route: '/broadcasts' }, // preview (compose-forma jonli ko'rinishi)
  'A15.09': { route: '/broadcasts' }, // test-yuborish (karta amali, POST .../action test)
  'A15.11': { route: '/broadcasts' }, // yuborishni to'xtatish (karta amali, POST .../action cancel)
  'A15.12': { route: '/broadcasts/scheduled' }, // yuborish jadvali (scheduled_at filtri)
  'A15.13': {}, // yuborish holati/karta (/broadcasts/:id — ro'yxatdan)
  'A15.17': { route: '/push/health' }, // push-provayder holati (fcm+token+status)
  'A15.19': { route: '/announcements' }, // Tizim xabarlari (majburiy) — e'lonlar/bannerlar (GET/POST /admin/announcements + public /announcements/active)
  'A15.21': { route: '/broadcasts/templates' }, // shablonlar kutubxonasi (broadcast_templates CRUD)
  'A15.10': { route: '/broadcasts/settings' }, // tezlik cheklovi (throttle) — broadcast_settings
  'A15.22': { route: '/broadcasts/settings' }, // anti-spam siyosati — broadcast_settings
  'A15.20': { route: '/broadcasts/banner' }, // xizmat/maintenance banner (service_banner + public GET)
  // A16 — analitika (mavjud /admin/analytics[/breakdown] + countries ustidan)
  'A16.01': { route: '/analytics/active-users' }, // DAU/WAU/MAU (A2.06 reuse)
  'A16.02': { route: '/analytics/new-users' }, // yangi foydalanuvchilar
  'A16.03': { route: '/analytics/retention' }, // retention (D1/D7/D30 rolling) — GET /admin/analytics/retention (users)
  'A16.04': { route: '/analytics/churn' }, // churn (D1/D7/D30 rolling, 1−retention) — GET /admin/analytics/retention
  'A16.05': { route: '/analytics/activity' }, // soatlik faollik
  'A16.06': { route: '/analytics/platform' }, // platforma bo'yicha
  'A16.07': { route: '/analytics/versions' }, // versiya bo'yicha (ilova/OS) — GET /admin/analytics/versions (user_devices)
  'A16.35': { route: '/analytics/bots' }, // bot ekotizimi statistikasi — GET /admin/analytics/bots (bots/bot_apps/bot_games)
  'A16.36': { route: '/analytics/top-bots' }, // top botlar/ilovalar (faol foydalanuvchi) — GET /admin/analytics/top-bots (bots)
  'A16.08': { route: '/geo/growth' }, // davlat bo'yicha (A11.20 reuse — bir xil data)
  'A16.09': { route: '/analytics/languages' }, // til bo'yicha — GET /admin/analytics/languages (user_settings.lang)
  'A16.31': { route: '/analytics/points' }, // Ball iqtisodiyoti — GET /admin/analytics/points (points_balance/ledger/purchases)
  'A16.33': { route: '/analytics/channel-boosts' }, // kanal boostlari (qo'llab-quvvatlash) — GET /admin/analytics/channel-boosts (channel_boosts)
  // A16 event/observability analitika — JONLI (Postgres-taxminiy: updates event-oqimi
  // + users/messages/wallet/referrals/job_runs/incidents; handlers/analytics_ext.go)
  'A16.17': { route: '/analytics/events/discovery' }, // event kashfiyoti (updates.type)
  'A16.18': { route: '/analytics/events/taxonomy' }, // event lug'ati (taksonomiya)
  'A16.19': { route: '/analytics/events/user-path' }, // foydalanuvchi yo'li (event-chuqurlik)
  'A16.16': { route: '/analytics/funnels/compare' }, // voronka taqqoslash (2-davr)
  'A16.20': { route: '/analytics/segments/compare' }, // segment taqqoslash (davlat×metrika)
  'A16.21': { route: '/analytics/cohorts' }, // kohorta konstruktori (retention grid)
  'A16.22': { route: '/analytics/forecast' }, // prognozlash (7-kun MA)
  'A16.39': { route: '/analytics/service-quality' }, // xizmat sifati (SLO/SLI — job/call/tiket/insident)
  'A16.40': { route: '/analytics/report-builder' }, // hisobot konstruktori (jonli metrika katalogi)
  'A16.37': { route: '/analytics/moderation' }, // moderatsiya KPI — GET /admin/analytics/moderation (reports)
  'A16.10': { route: '/analytics/messages' }, // xabar hajmi
  'A16.11': { route: '/analytics/chat-types' }, // chat turlari bo'yicha
  'A16.12': { route: '/analytics/sessions' }, // sessiya davomiyligi — GET /admin/analytics/sessions (user_devices umri)
  'A16.14': { route: '/analytics/funnel' }, // funnel tahlili
  'A16.27': { route: '/analytics/channel-growth' }, // kanal o'sishi — GET /admin/analytics/channel-growth (dialogs channel + dialog_members)
  'A16.38': { route: '/analytics/support' }, // support KPI — GET /admin/analytics/support (support_tickets)
  'A16.32': { route: '/analytics/ad-revenue' }, // reklama daromadi — GET /admin/analytics/ad-revenue (ad_campaigns)
  'A16.29': { route: '/analytics/invites' }, // taklif havolalari samaradorligi — GET /admin/analytics/invites (invite_links)
  'A16.23': { route: '/analytics/revenue' }, // daromad dashboard'i — GET /admin/analytics/revenue (ad_campaigns+market_trades+bot_star_charges)
  'A16.44': { route: '/analytics/metrics-dict' }, // metrikalar lug'ati (single source) — statik reference (backend'siz)
  'A16.24': { route: '/analytics/arpu' }, // ARPU/ARPPU — GET /admin/analytics/arpu (daromad / foydalanuvchi / to'lovchi)
  // A17 — infra monitoring (REAL live-read backend). Qolgan A17 ekranlar (DC/incident/
  // on-call/Horizon/deploy-history) HAQIQIY infra kutadi → halol «planned».
  'A17.01': { route: '/infra/services' }, // Xizmatlar holati — GET /admin/infra/services (pg/redis/minio ping+latency)
  'A17.15': { route: '/infra/redis' }, // Kesh holati (Redis) — GET /admin/infra/redis (INFO stats)
  'A17.16': { route: '/infra/storage' }, // Fayl saqlash (MinIO) — GET /admin/infra/storage (bucket objects+size)
  'A17.18': { route: '/infra/queue' }, // Media qayta ishlash navbati — GET /admin/infra/queue (LLEN)
  'A17.13': { route: '/reliability' }, // Xato darajasi (SLO) — incidents MTTR + job error-rate (read-only GET /admin/reliability/summary)
  'A17.08': { route: '/job-runs' }, // Ishlamayotgan job'lar — background-job monitor (error filtri, GET /admin/job-runs)
  'A17.09': { route: '/job-runs' }, // Cron/rejalashtirilgan vazifalar — kunlik-housekeeping runs + per-job xulosa
  'A17.24': { route: '/incidents' }, // Incidentlar ro'yxati — GET/POST /admin/incidents
  'A17.25': { route: '/incidents' }, // Incident kartasi + timeline (ro'yxatdan tanlanadi)
  'A17.26': { route: '/incidents' }, // Postmortem (incident yopishда root-cause+action)
  'A17.27': { route: '/oncall' }, // On-call jadval — GET/POST/DELETE /admin/oncall
  'A17.28': { route: '/status-page' }, // Status sahifasi boshqaruvi — komponent CRUD + public /status (open incidents)
  // A20 — reklama (lane C ekranlari + live backend /admin/ads/*). Qolgan 17 A20 ekran keyingi iteratsiya.
  'A20.01': { route: '/ads/advertisers' }, // Reklamachilar — GET /admin/ads/advertisers
  'A20.04': { route: '/ads/campaigns' }, // Kampaniyalar — GET /admin/ads/campaigns
  'A20.05': { route: '/ads/creatives' }, // Kreativlar moderatsiyasi — GET /admin/ads/creatives + moderate
  'A20.10': { route: '/ads/approval' }, // Kampaniya tasdiqlash — POST /admin/ads/campaigns/:id/status
  'A20.06': { route: '/ads/banned-categories' }, // Taqiqlangan kategoriyalar — GET/POST/DELETE /admin/ads/banned-categories
  'A20.11': { route: '/ads/stats' }, // Kampaniya statistikasi — GET /admin/ads/stats
  'A20.15': { route: '/ads/channel-revenue' }, // Kanal daromadi — GET /admin/ads/channel-revenue
  'A20.16': { route: '/ads/complaints' }, // Reklama shikoyatlari — GET /admin/ads/complaints + resolve
  'A20.20': { route: '/ads/policy' }, // Reklama siyosati — GET/PUT /admin/ads/policy
  // A19 — huquqiy so'rovlar (legal_requests tizimi)
  'A19.01': { route: '/legal' }, // so'rovlar ro'yxati + qo'shish
  'A19.12': { route: '/legal/rejected' }, // rad etilgan huquqiy so'rovlar
  'A19.13': { route: '/legal/transparency' }, // shaffoflik hisoboti (status+kind agregat)
  'A19.14': { route: '/gdpr-requests' }, // GDPR so'rovlari (DSAR) — access/export/erasure/... tracking + 30-kun muddat (GET/POST /admin/gdpr-requests)
  'A19.05': { route: '/emergency-requests' }, // Favqulodda so'rovlar (hayotga xavf) — GET/POST /admin/emergency-requests
  'A19.06': { route: '/legal-holds' }, // Ma'lumot saqlash buyrug'i (preservation/legal hold) — GET/POST /admin/legal-holds
  'A19.07': { route: '/takedowns' }, // Kontent o'chirish talablari (DMCA/court) — GET/POST /admin/takedowns
  'A19.02': {}, // so'rov kartasi + holat (/legal/:id — ro'yxatdan)
  // A18 — security
  'A18.01': { route: '/security/audit' },
  'A18.02': { route: '/security/audit-search' }, // server-side filtrli audit qidiruv (action/admin/target/sana)
  'A18.03': { route: '/security/pii-access' }, // PII kirish jurnali — shaxsiy/kredensial ma'lumotga kirish (admin_audit pii.*, superadmin-only)
  'A18.05': { route: '/security/suspicious' }, // shubhali xodim (destruktiv-amal outlier, audit agregat)
  'A18.04': { route: '/security/staff' }, // xodim faoliyati (audit agregat)
  'A18.06': { route: '/security/four-eyes' },
  'A18.07': { route: '/jit/access' }, // JIT huquq so'rovlari — so'rov→four-eyes tasdiq→vaqt-cheklangan grant (GET/POST /admin/jit/requests)
  'A18.08': { route: '/jit/break-glass' }, // Break-glass jurnali — favqulodda self-grant (GET/POST /admin/jit/break-glass)
  'A18.10': { route: '/security-posture' }, // Risk skoring / security-posture — read-only aggregate (JIT/break-glass/fraud/moderation) GET /admin/security-posture
  'A18.23': { route: '/compliance' }, // Compliance holati — read-only aggregate (GDPR/holds/takedowns/emergency/consents) GET /admin/compliance/summary
  // A23 — staff
  'A23.04': { route: '/staff/permissions' },
  'A24.01': { route: '/settings/system' }, // Tizim sozlamalari — GET/PUT /admin/settings/system (maintenance + live config)
  'A24.05': { route: '/settings/sms-providers' }, // SMS provayderlar (Infobip balans+statistika) — GET /admin/sms/stats
  'A24.19': { route: '/legal-docs' }, // Qonuniy hujjatlar (ToS/Privacy) — versiya + nashr (GET/POST /admin/legal-docs)
  'A24.20': { route: '/legal-docs' }, // Hujjat versiyalari va roziliklar (bir ekranda — consent statistikasi)
  'A24.21': { route: '/maintenance-windows' }, // Texnik ishlar rejimi — rejalashtirilgan oyna (GET/POST /admin/maintenance, public /status)
  'A24.22': { route: '/settings/config-history' }, // O'zgarishlar tarixi — config-mutatsiya lens (admin_audit config-action: flag/module/system-setting/experiment)
  'A21.19': { route: '/music/library' }, // musiqa kutubxonasi (moderatsiya) — GET/POST/DELETE /admin/music/songs*
  'A23.08': { route: '/communities' }, // jamoalar — GET /admin/communities (communities + community_groups)
  // A12 SEO / A13 developers / A25 antifraud / A26 automation / A27 devtools — registratsiya 2026-07-23
  // (backend 401=jonli → live; devtools cache/restart/migrations 404 → skeleton, halol)
  'A12.05': { route: '/seo/robots' },
  'A12.11': { route: '/seo/redirects' },
  'A12.12': { route: '/seo/not-found' },
  'A13.01': { route: '/developers/apps' },
  'A13.07': { route: '/developers/bot-tokens' },
  'A13.08': { route: '/developers/leaked' },
  'A13.16': { route: '/developers/webhooks' },
  'A13.18': { route: '/developers/oauth' },
  'A13.04': { route: '/developers/rate-limits' },
  'A25.07': { route: '/antifraud/events' },
  'A25.02': { route: '/antifraud/rules' },
  'A25.15': { route: '/antifraud/blacklist' },
  'A25.09': { route: '/antifraud/devices' },
  'A25.12': { route: '/antifraud/payments' },
  'A25.14': { route: '/antifraud/referral-abuse' },
  'A26.01': { route: '/automation/workflows' },
  'A26.05': { route: '/automation/executions' },
  'A26.07': { route: '/automation/scheduled' },
  'A26.08': { route: '/automation/triggers' },
  'A26.09': { route: '/automation/webhooks' },
  'A26.06': { route: '/automation/errors' },
  'A27.01': { route: '/devtools/console' },
  'A27.08': { route: '/devtools/test-users' },
  'A27.14': { route: '/devtools/health' },
  'A27.11': { route: '/devtools/cache' },
  'A27.12': { route: '/devtools/restart' },
  'A27.10': { route: '/devtools/migrations' },
  // --- BATCH-1 (2026-07-26): A1/A9/A14/A19/A22/A26 ---
  'A1.02': { route: '/auth/hardware-2fa' },
  'A1.08': { route: '/auth/onboarding' },
  'A9.03': { route: '/verification/review' },
  'A9.04': { route: '/verification/review' },
  'A9.05': { route: '/verification/review' },
  'A9.06': { route: '/verification/review' },
  'A9.07': { route: '/verification/manage' },
  'A9.08': { route: '/verification/manage' },
  'A9.09': { route: '/verification/verifiers' },
  'A9.10': { route: '/verification/verifiers' },
  'A9.11': { route: '/verification/verifiers/audit' },
  'A14.11': { route: '/flags/experiment-results' },
  'A14.15': { route: '/flags/rollout-status' },
  'A19.03': { route: '/legal/basis' },
  'A19.04': { route: '/legal/jurisdiction' },
  'A19.08': { route: '/legal/blocking' },
  'A19.09': { route: '/legal/collection' },
  'A19.10': { route: '/legal/response-prep' },
  'A19.11': { route: '/legal/send-confirm' },
  'A19.15': { route: '/legal/data-export' },
  'A19.16': { route: '/legal/erasure' },
  'A22.07': { route: '/localization/versions' },
  'A22.08': { route: '/localization/community' },
  'A22.09': { route: '/localization/translators' },
  'A22.12': { route: '/localization/screenshots' },
  'A26.02': { route: '/automation/builder' },
  'A26.03': { route: '/automation/conditions' },
  'A26.04': { route: '/automation/test' },
  'A26.10': { route: '/automation/integrations' },
  'A26.11': { route: '/automation/scripts' },
  'A26.12': { route: '/automation/audit' },
  // --- BATCH-2 (2026-07-26): A4/A5/A15/A20/A23/A25 ---
  'A15.03': { route: '/broadcasts/audience' },
  'A15.04': { route: '/broadcasts/segments' },
  'A15.05': { route: '/broadcasts/editor' },
  'A15.07': { route: '/broadcasts/ab' },
  'A15.08': { route: '/broadcasts/approvals' },
  'A15.14': { route: '/broadcasts/delivery' },
  'A15.15': { route: '/broadcasts/engagement' }, // JONLI: yetkazish-qamrov + push deliverability (broadcasts+push_tokens)
  'A15.16': { route: '/broadcasts/unsubscribes' }, // JONLI: bildirishnoma opt-out'lar (notify_override/mute)
  'A15.18': { route: '/broadcasts/token-health' },
  'A25.01': { route: '/antifraud/risk' },
  'A25.03': { route: '/antifraud/rules/new' },
  'A25.04': { route: '/antifraud/backtest' },
  'A25.05': { route: '/antifraud/models' },
  'A25.06': { route: '/antifraud/scoring' },
  'A25.08': { route: '/antifraud/auto-actions' },
  'A25.10': { route: '/antifraud/linked' },
  'A25.11': { route: '/antifraud/synthetic' },
  'A25.13': { route: '/antifraud/stars' },
  'A25.16': { route: '/antifraud/reports' },
  'A5.07': { route: '/bots/rate-limits' },
  'A5.11': { route: '/bots/restrict' },
  'A5.13': { route: '/bots/delete' },
  'A5.15': { route: '/bots/vip-limits' },
  'A5.18': { route: '/mini-apps/queue' },
  'A5.19': { route: '/mini-apps/url-security' },
  'A5.21': { route: '/mini-apps/catalog' },
  'A5.22': { route: '/mini-apps/categories' },
  'A5.23': { route: '/mini-apps/reviews' },
  'A5.24': { route: '/mini-apps/suspend' },
  'A5.25': { route: '/mini-apps/delete' },
  'A20.02': { route: '/ads/advertiser-card' },
  'A20.03': { route: '/ads/balance' },
  'A20.07': { route: '/ads/targeting' },
  'A20.08': { route: '/ads/placements' },
  'A20.09': { route: '/ads/placement-remove' },
  'A20.12': { route: '/ads/placements-overview' },
  'A20.13': { route: '/ads/pricing' },
  'A20.14': { route: '/ads/auction' },
  'A20.17': { route: '/ads/fraud' },
  'A20.18': { route: '/ads/brand-safety' },
  'A20.19': { route: '/ads/reports' },
  'A4.02': { route: '/group-ops/search' },
  'A4.03': { route: '/group-ops/bulk' },
  'A4.11': { route: '/group-ops/linked' }, // JONLI: community_groups kanal↔guruh bog'lanishi
  'A4.15': { route: '/group-ops/pinned' }, // JONLI: pinned_messages ⨝ messages
  'A4.18': { route: '/group-ops/ads' }, // JONLI: kanal broadcast postlari + qamrov (messages+dialogs)
  'A4.20': { route: '/group-ops/monetization' }, // JONLI: channel_boosts (bepul-boost modeli)
  'A4.23': { route: '/group-ops/warn' },
  'A4.24': { route: '/group-ops/restrict' },
  'A4.25': { route: '/group-ops/purge' },
  'A4.26': { route: '/group-ops/hide' },
  'A4.31': { route: '/group-ops/archive' },
  'A4.32': { route: '/group-ops/delete' },
  'A23.05': { route: '/staff/role-editor' },
  'A23.06': { route: '/staff/access-requests' },
  'A23.07': { route: '/staff/jit' },
  'A23.09': { route: '/staff/assignment-rules' },
  'A23.10': { route: '/staff/shifts' },
  'A23.11': { route: '/staff/workload' },
  'A23.12': { route: '/staff/kpi' },
  'A23.13': { route: '/staff/onboarding' },
  'A23.14': { route: '/staff/offboarding' },
  'A23.15': { route: '/staff/activity' },
  'A23.16': { route: '/staff/announcements' },
  'A23.17': { route: '/staff/training' },
  'A23.18': { route: '/staff/settings' },
  // --- BATCH-3 (2026-07-26): A8/A11/A13/A16/A17/A18 ---
  'A8.05': { route: '/strikes/manual' },
  'A8.06': { route: '/strikes/revoke' },
  'A8.07': { route: '/strikes/duration' },
  'A8.12': { route: '/appeals/decisions' },
  'A8.13': { route: '/strikes/amnesty' },
  'A8.14': { route: '/strikes/wrongful-bans' },
  'A8.20': { route: '/strikes/fairness' },
  'A8.04': { route: '/strikes/auto-rules' }, // LIVE /admin/ban-rules (000245)
  'A8.08': { route: '/strikes/spam-waves' }, // LIVE mass-restriction over real users
  'A8.09': { route: '/strikes/templates' }, // LIVE /admin/ban-templates (000245)
  'A8.15': { route: '/strikes/reasons' }, // LIVE /admin/ban-reasons (000245)
  'A8.16': { route: '/blocks/devices' }, // LIVE /admin/ip-blocks (000245)
  'A8.17': { route: '/blocks/phones' }, // LIVE /admin/phone-blocks (000245)
  'A8.18': { route: '/blocks/reregistration' }, // LIVE merged ip+phone blocks
  'A13.02': { route: '/developers/app-card' },
  'A13.03': { route: '/developers/usage' },
  'A13.05': { route: '/developers/app-block' },
  'A13.06': { route: '/developers/abuse' },
  'A13.09': { route: '/developers/forced-revoke' },
  'A13.10': { route: '/developers/vip-limits' },
  'A13.11': { route: '/developers/rotation-log' },
  'A13.12': { route: '/developers/service-keys' },
  'A13.17': { route: '/developers/provider-keys' },
  'A13.19': { route: '/developers/key-policy' },
  'A13.20': { route: '/developers/key-audit' },
  'A13.13': { route: '/developers/kms' },
  'A13.14': { route: '/developers/key-export' },
  'A13.15': { route: '/developers/certs' },
  'A18.09': { route: '/security/incidents' },
  'A18.11': { route: '/security/fraud-rules' },
  'A18.12': { route: '/security/fraud-cases' },
  'A18.13': { route: '/security/anomaly' },
  'A18.14': { route: '/security/bot-farms' },
  'A18.15': { route: '/security/mass-registration' },
  'A18.16': { route: '/security/credential-stuffing' },
  'A18.19': { route: '/security/ip-lists' },
  'A18.24': { route: '/security/policies' },
  'A18.17': { route: '/security/ddos' },
  'A18.18': { route: '/security/waf' },
  'A18.20': { route: '/security/vuln-scans' },
  'A18.21': { route: '/security/dependency-audit' },
  'A18.22': { route: '/security/pentest' },
  'A11.01': { route: '/geo/map' },
  'A11.05': { route: '/geo/rollout' },
  'A11.06': { route: '/geo/feature-restrictions' },
  'A11.07': { route: '/geo/payment-restrictions' },
  'A11.08': { route: '/geo/content-restrictions' },
  'A11.09': { route: '/geo/locale' },
  'A11.10': { route: '/geo/operators' },
  'A11.12': { route: '/geo/blocked-ranges' },
  'A11.19': { route: '/geo/legal-registry' },
  'A11.21': { route: '/geo/anomalies' },
  'A11.13': { route: '/geo/ip-geo' }, // JONLI — geo_ip_ranges CRUD (000247)
  'A11.14': { route: '/geo/vpn' }, // JONLI — geo_vpn_ranges CRUD + aniqlash tumbleri (000247)
  'A11.15': { route: '/geo/tor' }, // JONLI — geo_tor_nodes CRUD (000247)
  'A11.16': { route: '/geo/dc-routing' }, // JONLI — geo_dc_routes CRUD (000247)
  'A11.17': { route: '/geo/residency' }, // JONLI — geo_residency CRUD (000247)
  'A11.23': { route: '/geo/premium-pricing' }, // davlat bo'yicha Premium narxlari (upsert overlay)
  'A16.34': { route: '/analytics/bot-ecosystem' },
  'A16.41': { route: '/analytics/scheduled-reports' },
  'A16.42': { route: '/analytics/export-center' },
  'A16.43': { route: '/analytics/data-dictionary' },
  'A16.13': { route: '/analytics/screen-time' }, // JONLI (Postgres-taxminiy: updates faollik-oralig'i)
  'A16.15': { route: '/analytics/funnel-builder' }, // JONLI (users→profil→xabar→faol voronka)
  'A16.25': { route: '/analytics/ltv' }, // JONLI (oy-kohort hamyon kirimi)
  'A16.26': { route: '/analytics/conversion-funnel' }, // JONLI (ro'yxat→xabar→to'ldirish→sarf)
  'A16.28': { route: '/analytics/viral' }, // JONLI (referral viral koeffitsienti)
  'A16.30': { route: '/analytics/premium-conversion' }, // JONLI (is_premium ulushi)
  'A17.10': { route: '/infra/error-logs' },
  'A17.14': { route: '/infra/db' },
  'A17.23': { route: '/infra/migrations' },
  // A17.02-22 — REAL single-node infra (host /proc + registries + live Redis/pg reads). No skeleton.
  'A17.02': { route: '/infra/servers' }, // Server ro'yxati — GET /admin/infra/host (jonli uzel) + /admin/infra/servers (registri CRUD)
  'A17.03': { route: '/infra/datacenters' }, // Data-markazlar — /admin/infra/datacenters (serverlar DC bo'yicha + jonli uzel)
  'A17.04': { route: '/infra/dc-load' }, // DC yuklamasi — /admin/infra/host jonli CPU/mem/disk/load gaugelar
  'A17.05': { route: '/infra/dc-assignment' }, // User→DC — /admin/infra/datacenters (barcha user yagona DC'да, single-node)
  'A17.06': { route: '/infra/migration-control' }, // Migratsiya boshqaruvi — /admin/devtools/migrations (schema_migrations)
  'A17.07': { route: '/infra/queues' }, // Navbatlar — /admin/infra/queue + /admin/infra/redis (jonli Redis navbat chuqurligi)
  'A17.11': { route: '/infra/slow-queries' }, // Sekin so'rovlar — /admin/infra/slow-queries (pg_stat_statements, mavjud bo'lsa)
  'A17.12': { route: '/infra/api-latency' }, // API javob vaqtlari — /admin/infra/api-metrics (jarayon /metrics hisoblagichlari)
  'A17.17': { route: '/infra/cdn' }, // CDN holati — /admin/infra/cdn (app_settings config, admin-managed)
  'A17.19': { route: '/infra/backups' }, // Backup holati — /admin/infra/backups (backup yugurishlari registri)
  'A17.20': { route: '/infra/restore-drill' }, // Restore drill — /admin/infra/backups?kind=restore_drill
  'A17.21': { route: '/infra/deploys' }, // Deploy tarixi — /admin/infra/deploys (+ joriy schema/build versiya)
  'A17.22': { route: '/infra/rollback' }, // Rollback — /admin/infra/deploys/:id/rollback (audited action + deploy list)
  // --- BATCH-4 (2026-07-26): A3/A6/A7/A12/A21/A24 ---
  'A24.02': { route: '/settings/branding' },
  'A24.03': { route: '/settings/domains' },
  'A24.04': { route: '/settings/smtp' },
  'A24.07': { route: '/settings/file-storage' },
  'A24.09': { route: '/settings/search-index' },
  'A24.10': { route: '/settings/cache' },
  'A24.11': { route: '/settings/registration' },
  'A24.12': { route: '/settings/media-limits' },
  'A24.13': { route: '/settings/message-limits' },
  'A24.14': { route: '/settings/group-limits' },
  'A24.15': { route: '/settings/bot-limits' },
  'A24.16': { route: '/settings/premium-packages' },
  'A24.17': { route: '/settings/pricing' },
  'A24.18': { route: '/legal-docs' },
  'A24.06': { route: '/settings/push-certs' },
  'A24.08': { route: '/settings/cdn' },
  'A7.01': { route: '/complaints' },
  'A7.02': {},
  'A7.05': { route: '/complaints/unfounded' },
  'A7.08': { route: '/support/history' },
  'A7.09': { route: '/support/assign' },
  'A7.10': { route: '/support/priority' },
  'A7.11': { route: '/support/tags' },
  'A7.12': { route: '/support/merge' },
  'A7.16': { route: '/support/macros' },
  'A7.18': { route: '/support/notes' },
  'A7.19': { route: '/support/kb' },
  'A7.20': { route: '/support/auto-replies' },
  'A7.21': { route: '/support/csat' },
  'A7.22': { route: '/support/agents' },
  'A7.23': { route: '/support/workload' },
  'A7.24': { route: '/support/reports' },
  'A3.02': { route: '/users/search' },
  'A3.03': { route: '/users/segments' },
  'A3.04': { route: '/users/bulk' },
  'A3.05': { route: '/users/export' },
  'A3.06': { route: '/users/import' },
  'A3.23': { route: '/users/pii-log' },
  'A3.08': {}, 'A3.24': {}, 'A3.25': {}, 'A3.27': {}, 'A3.30': {}, 'A3.32': {},
  'A3.33': {}, 'A3.34': {}, 'A3.35': {}, 'A3.36': {}, 'A3.37': {},
  'A21.02': { route: '/catalog/sticker-moderation' },
  'A21.03': { route: '/catalog/trending-stickers' },
  'A21.04': { route: '/catalog/copyright' },
  'A21.05': { route: '/catalog/sticker-authors' },
  'A21.07': { route: '/catalog/emoji-sets' },
  'A21.08': { route: '/catalog/emoji-statuses' },
  'A21.09': { route: '/catalog/reactions' },
  'A21.10': { route: '/catalog/emoji-moderation' },
  'A21.11': { route: '/catalog/featured' },
  'A21.12': { route: '/catalog/mini-apps' },
  'A21.13': { route: '/catalog/categories' },
  'A21.15': { route: '/catalog/search-ranking' },
  'A21.16': { route: '/catalog/media-stats' },
  'A21.18': { route: '/catalog/reports' },
  'A21.06': { route: '/catalog/tgs-validation' },
  'A21.14': { route: '/catalog/recommendation' },
  'A21.17': { route: '/catalog/duplicate-media' },
  'A12.01': { route: '/seo/dashboard' },
  'A12.02': { route: '/seo/meta' },
  'A12.03': { route: '/seo/opengraph' },
  'A12.04': { route: '/seo/canonical' },
  'A12.06': { route: '/seo/sitemap' },
  'A12.07': { route: '/seo/index-policy' },
  'A12.08': { route: '/seo/noindex' },
  'A12.09': { route: '/seo/schema' },
  'A12.10': { route: '/seo/hreflang' },
  'A12.22': { route: '/seo/landing' },
  'A12.23': { route: '/seo/blog' },
  'A12.24': { route: '/seo/miniapp' },
  'A12.25': { route: '/seo/deeplink' },
  'A12.13': { route: '/seo/keywords' },
  'A12.14': { route: '/seo/competitors' },
  'A12.15': { route: '/seo/content-gaps' },
  'A12.16': { route: '/seo/internal-links' },
  'A12.17': { route: '/seo/web-vitals' },
  'A12.18': { route: '/seo/page-speed' },
  'A12.19': { route: '/seo/mobile' },
  'A12.20': { route: '/seo/search-console' },
  'A12.21': { route: '/seo/yandex' },
  'A12.26': { route: '/seo/audit' },
  'A6.09': { route: '/moderation/bots' },
  'A6.10': { route: '/moderation/stickers' },
  'A6.11': { route: '/moderation/usernames' },
  'A6.12': { route: '/moderation/avatars' },
  'A6.14': { route: '/moderation/review-queue' },
  'A6.16': { route: '/moderation/context' },
  'A6.17': { route: '/moderation/user-history' },
  'A6.19': { route: '/moderation/decision' },
  'A6.22': { route: '/moderation/second-opinion' },
  'A6.26': { route: '/moderation/hashes' },
  'A6.28': { route: '/moderation/keywords' },
  'A6.31': { route: '/moderation/file-hashes' },
  'A6.32': { route: '/moderation/whitelists' },
  'A6.33': { route: '/moderation/rules' },
  'A6.34': { route: '/moderation/rule-test' },
  'A6.37': { route: '/moderation/audit' },
  'A6.39': { route: '/moderation/errors' },
  'A6.40': { route: '/moderation/training' },
  'A6.41': { route: '/moderation/policies' },
  'A6.42': { route: '/moderation/transparency' },
  'A6.18': { route: '/moderation/similar' },
  'A6.23': { route: '/moderation/ml-models' },
  'A6.24': { route: '/moderation/model-quality' },
  'A6.25': { route: '/moderation/thresholds' },
  'A6.27': { route: '/moderation/phash' },
  'A6.38': { route: '/moderation/inter-rater' },
  // --- BATCH-5 (2026-07-26): A27 dev-tools (final) ---
  'A27.02': { route: '/devtools/requests' },
  'A27.03': { route: '/devtools/webhook-debug' },
  'A27.04': { route: '/devtools/updates' },
  'A27.06': { route: '/devtools/trace' },
  'A27.09': { route: '/devtools/generate' },
  'A27.13': { route: '/devtools/config-diff' },
  'A27.05': { route: '/devtools/events' },
  'A27.07': { route: '/devtools/sandbox' },
}

// Skelet ekranlar (skeleton:true) "jonli" HISOBLANMAYDI — faqat mo'ljal + adapter tayyor.
export const isLive = (id: string): boolean => id in SCREEN_STATUS && !SCREEN_STATUS[id]?.skeleton
export const isSkeleton = (id: string): boolean => Boolean(SCREEN_STATUS[id]?.skeleton)
export const screenRoute = (id: string): string | undefined => SCREEN_STATUS[id]?.route

/** Modul bo'yicha jonli ekranlar soni (skeletlar kirmaydi). */
export function liveCount(ids: string[]): number {
  return ids.reduce((n, id) => n + (isLive(id) ? 1 : 0), 0)
}
